var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "properties-field", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "wrap-properties" }, [
        _c("div", { staticClass: "properties-field-title" }, [
          _c("h4", { staticClass: "title" }, [_vm._v("Configuration")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: {
                click: function($event) {
                  !_vm.showModalFieldLibrary ? _vm.closeConfiguration() : null
                }
              }
            },
            [_vm._v("\n        ×\n      ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "properties-field-content properties-field-content-config"
          },
          [
            _c(
              "div",
              { staticClass: "section-field input-field" },
              [
                _c(
                  "b-form",
                  {
                    staticClass: "input-field m__b--14",
                    class: { "error-input": _vm.$v.dataSetup.title.$error }
                  },
                  [
                    _c("label", [_vm._v(" Title ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: {
                        "error-required": false,
                        placeholder: "Enter title view"
                      },
                      model: {
                        value: _vm.dataSetup.title,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "title", $$v)
                        },
                        expression: "dataSetup.title"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("div", { staticClass: "configuration-toggle-in-title" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-option" }, [
                      _c("div", { staticClass: "filter-selected" }, [
                        _vm._v(_vm._s(_vm.dataSetup.filterOperator))
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-chevron-down",
                        on: {
                          click: function($event) {
                            _vm.showFilterOptions = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.showFilterOptions
                        ? _c("div", { staticClass: "filter-options" }, [
                            _c("p", [_vm._v("Operator")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-around"
                              },
                              _vm._l(_vm.filterOperatorOptions, function(
                                operator
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: operator.id,
                                    staticClass: "operator-option",
                                    class: {
                                      "operator-selected":
                                        operator.id ===
                                        _vm.dataSetup.filterOperator
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.closeFilterOptions(operator.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(operator.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              })
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "configuration-section-subtitle" }, [
                    _vm._v("By Value")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.filter, function(data, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "div-filter" },
                      [
                        _c("div", { staticClass: "header-filter" }, [
                          _c("div", { staticClass: "index" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-trash",
                            on: {
                              click: function($event) {
                                _vm.deleteFilter(index)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          { staticClass: "mb-2" },
                          [
                            _c("label", [_vm._v(" Column ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                "error-required": false,
                                options: _vm.variableOptions,
                                placeholder: "Select Column",
                                "value-format": "object",
                                label: "label"
                              },
                              model: {
                                value: data.key,
                                callback: function($$v) {
                                  _vm.$set(data, "key", $$v)
                                },
                                expression: "data.key"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Value ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: {
                                "error-required": false,
                                placeholder: "Input Filter Value"
                              },
                              model: {
                                value: data.value,
                                callback: function($$v) {
                                  _vm.$set(data, "value", $$v)
                                },
                                expression: "data.value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addFilter }
                    },
                    [_vm._v("\n            + Add Parameter\n          ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "separator" }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "configuration-section-subtitle" }, [
                    _vm._v("By Function")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.filter_function, function(data, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "div-filter" },
                      [
                        _c("div", { staticClass: "header-filter" }, [
                          _c("div", { staticClass: "index" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-trash",
                            on: {
                              click: function($event) {
                                _vm.deleteFilterFunction(index)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          { staticClass: "mb-2" },
                          [
                            _c("label", [_vm._v(" Column ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                "error-required": false,
                                options: _vm.variableOptions,
                                placeholder: "Select Column",
                                "value-format": "object",
                                label: "label"
                              },
                              model: {
                                value: data.key,
                                callback: function($$v) {
                                  _vm.$set(data, "key", $$v)
                                },
                                expression: "data.key"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Function ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.listFunction,
                                placeholder: "Select Function",
                                "error-required": false,
                                label: "name"
                              },
                              model: {
                                value: data.value,
                                callback: function($$v) {
                                  _vm.$set(data, "value", $$v)
                                },
                                expression: "data.value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addFilterFunction }
                    },
                    [_vm._v("\n            + Add Parameter\n          ")]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("h4", { staticClass: "configuration-section-title" }, [
                    _vm._v("Rows Per Page")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "configuration-section-desc" }, [
                    _vm._v(
                      "\n            Option list for total rows per page  as a default, and the\n            maximum limit that can be applied per page is 10,000 records.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.rows_page_option, function(
                    option,
                    index
                  ) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        {
                          staticClass: "div-row-page-option",
                          class: {
                            "error-input":
                              _vm.dataSetup.rows_page_option.length > 0 &&
                              _vm.$v.dataSetup.rows_page_option.$each[index]
                                .$error
                          }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.dataSetup.rows_page_default,
                                expression: "dataSetup.rows_page_default"
                              }
                            ],
                            attrs: {
                              id: option,
                              disabled: option === "",
                              type: "radio"
                            },
                            domProps: {
                              value: option,
                              checked: _vm._q(
                                _vm.dataSetup.rows_page_default,
                                option
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.$set(
                                  _vm.dataSetup,
                                  "rows_page_default",
                                  option
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.dataSetup.rows_page_option[index],
                                expression: "dataSetup.rows_page_option[index]"
                              }
                            ],
                            attrs: { type: "number", placeholder: "Option" },
                            domProps: {
                              value: _vm.dataSetup.rows_page_option[index]
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.dataSetup.rows_page_option,
                                  index,
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-trash cursor-pointer",
                            on: {
                              click: function($event) {
                                _vm.deleteRowPageOption(index)
                              }
                            }
                          })
                        ]
                      )
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addRowPageOption }
                    },
                    [_vm._v("\n            + Add Option\n          ")]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "configuration-section" }, [
                _c(
                  "div",
                  { staticClass: "configuration-toggle-in-title" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("j-toggle", {
                      staticClass: "toggle",
                      model: {
                        value: _vm.dataSetup.freeze_header_table,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "freeze_header_table", $$v)
                        },
                        expression: "dataSetup.freeze_header_table"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Search Options")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("h4", { staticClass: "configuration-section-title" }, [
                    _vm._v("Fields")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "configuration-section-desc" }, [
                    _vm._v(
                      "\n            The field used can be adjusted as needed\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "d-flex flex-wrap",
                      attrs: {
                        options: {
                          animation: 300,
                          handle: ".icon-drag"
                        }
                      },
                      model: {
                        value: _vm.dataSetup.search_options_list,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "search_options_list", $$v)
                        },
                        expression: "dataSetup.search_options_list"
                      }
                    },
                    _vm._l(_vm.dataSetup.search_options_list, function(
                      data,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "field-list",
                          class: { selected: index === _vm.selectedIndexField }
                        },
                        [
                          _c("p", { staticClass: "column-name" }, [
                            _vm._v(_vm._s(data.name))
                          ]),
                          _vm._v(" "),
                          _c("field-preview", { attrs: { column: data } }),
                          _vm._v(" "),
                          _c("div", { staticClass: "edit-or-delete" }, [
                            _c("div", { staticClass: "button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "edit",
                                  on: {
                                    click: function($event) {
                                      _vm.editField(index)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-pencil-square-o"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "delete",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteField(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: {
                        click: function($event) {
                          _vm.openModalFieldLibrary("export")
                        }
                      }
                    },
                    [_vm._v("\n            + Add Field\n          ")]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "properties-field-button",
            class: { "justify-content-end": !_vm.isHaveConfiguration }
          },
          [
            _vm.isHaveConfiguration
              ? _c(
                  "button",
                  {
                    staticClass: "button-border",
                    attrs: { disabled: _vm.showModalFieldLibrary },
                    on: { click: _vm.deleteView }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete View\n      ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  attrs: { disabled: _vm.showModalFieldLibrary },
                  on: { click: _vm.closeConfiguration }
                },
                [_vm._v("\n          Close\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-blue",
                  attrs: { disabled: _vm.showModalFieldLibrary },
                  on: { click: _vm.submitForm }
                },
                [_vm._v("\n          Apply\n        ")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.selectedField
        ? _c("properties-field", {
            ref: _vm.idProperties,
            attrs: {
              id: [_vm.idProperties],
              "field-detail": _vm.selectedField,
              "variable-options": _vm.variables,
              "field-ui-key": _vm.dataSetup.search_options_list,
              "is-detail-view": true,
              "is-group": true,
              "is-new-field": _vm.isNewFieldGroup
            },
            on: {
              "delete-field": _vm.deleteField,
              "close-properties": function($event) {
                _vm.togglePropertiesField(false)
              },
              "submit-mode": _vm.submitField
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Filter")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Filter data according to the parameters\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Freeze Header Table")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Prevents the row headers of a table from scrolling out\n                of view while examining extensive data\n              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-933f975e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-933f975e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/ExportViewConfiguration.vue
// module id = null
// module chunks = 